module.exports = __webpack_public_path__ + "e5d9a7d9.svg";